import { getUserWarehouse } from "./ModelMaintenance";

const getKind = () => {
  const options = [{ id: "equipment", name: "Equipment" }];
  return options;
};

const onChangeEquipment = (_, record) => {
  if (record.active.equipment) {
    const kindOption = getKind().find((opt) => opt.id === "equipment");
    record.store.kind = kindOption;
    record.active.kind = kindOption;
  }
};

function getEfficancyRequired(record) {
  return record?.state === "done";
}

function invisibleButton(btn, record) {
  if (!record?.state) return true;
  const state = record.state;
  if (btn === "done") return !["assigned", "approved"].includes(state);
  if (btn === "marked") {
    if (!["done"].includes(state)) return true;
    if (record.efficacy?.id === "no") return true;
    return false;
  }
  return false;
}
const stateTags = {
  open: "slate",
  assigned: "blue",
  done: "amber",
  marked: "indigo",
};
const getPriority = () => {
  const options = [
    { id: "urgent", name: "Urgente" },
    { id: "important", name: "Importante" },
    { id: "low", name: "Baja" },
  ];
  return options;
};

const getEfficacy = () => {
  const options = [
    { id: "yes", name: "Si" },
    { id: "no", name: "No" },
  ];
  return options;
};

async function layout() {
  const warehouseId = await getUserWarehouse();

  const ctxView = {
    model: "maintenance.request_service",
    tags: { state: stateTags },
    form_action: ["edit", "add"],
    table_action: ["add", "open"],
    activeSearch: true,
    domain: warehouseId
      ? [["equipment.warehouse", "=", warehouseId]] : [],
    fields: {
      number: { type: "char", readOnly: true },
      kind: {
        type: "selection",
        options: getKind(),
        required: true,
        readOnly: true,
      },
      equipment: {
        type: "many2one",
        model: "maintenance.equipment",
        searchable: true,
        required: true,
        withChange: onChangeEquipment,
        dependents: ["kind"],
        recSearch: () => {
          if (warehouseId) {
            return ["warehouse", "=", warehouseId];
          }
          return null;
        },
      },
      piece: { type: "char" },
      request_date: {
        type: "date_2",
      },
      type_activity: {
        type: "many2one",
        model: "maintenance.type_activity",
      },
      priority: {
        type: "selection",
        options: getPriority(),
        required: true,
      },
      effective_date: { type: "date_2", readOnly: true },
      description: { type: "text", required: true },
      approved_notes: {type: "text", getRequired: getEfficancyRequired},
      action: { type: "text", readOnly: true },
      state: { type: "char", readOnly: true, translate: true, tags: stateTags },
      efficacy: {
        type: "selection",
        options: getEfficacy(),
        getRequired: getEfficancyRequired,
      },
      marked: {
        type: "button",
        button_method: "marked",
        invisible: invisibleButton,
        color: "amber",
      }
    },
    list: [
      { name: "number" },
      { name: "equipment" },
      { name: "kind" },
      { name: "priority" },
      { name: "request_date" },

      { name: "state", widget: "circle" },
    ],
    form: [
      {
        name: "block_header1",
        type: "grid",
        col: "grid-cols-2",
        colSpan: "col-span-3",

        elements: [
          { name: "equipment" },
          { name: "kind" },
          { name: "priority" },
          { name: "number" },
          { name: "efficacy" },
        ],
      },
      {
        name: "block_header2",
        type: "grid",
        col: "grid-cols-4",
        colSpan: "col-span-4",
        elements: [
          { name: "piece" },
          { name: "request_date" },
          { name: "effective_date" },
          { name: "type_activity" },
        ],
      },
      {
        name: "block_description",
        type: "grid",
        col: "grid-cols-2",
        colSpan: "col-span-2",
        elements: [{ name: "description" }, {name:"approved_notes"},{ name: "action" }],
      },
      {
        name: "actions",
        type: "grid",
        cols: "grid-cols-1",
        colSpan: "col-span-4",
        elements: [{ name: "marked" }],
      },
    ],
  };
  return ctxView;
}

export { layout };
